import React, { useRef, useEffect, useState } from 'react'
import useCasinoTransactionsList from './hooks/useCasinoTransactionsList'
import { Button, Col, Row, Form } from '@themesberg/react-bootstrap'
import DateRangePicker from '../../../components/DateRangePicker'
import { getDateDaysAgo } from '../../../utils/dateFormatter'
import { transactionType, statusType } from './constants'
import CasinoTransactionsList from '../../../components/CasinoTransactionList'
import ClientFilter from '../../../components/ClientFilter'
import PortalFilter from '../../../components/PortalFilter'
import { toast } from '../../../components/Toast'
import Trigger from '../../../components/OverlayTrigger'
import { downloadFile } from '../../../utils/fileDownloader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRedoAlt, faFileDownload } from '@fortawesome/free-solid-svg-icons'
import NotificationIconContainer from '../../../components/NotificationIcon/NotificationIconContainer'
import { CustomCol } from '../TransactionsBanking/style'
import { tableCasinotransactionColumns } from "./constants"
import useTableCustom from "../../../components/CusotmFilter"
import TableErrorMessage from "../../../components/TableErrorMessage";
import DateFilterDropdown from "../../../components/CustomDateFilterOptions";



const CasinoTransactions = () => {
  const {
    allCurrencies,
    setSelectedCurrency,
    setSearch,
    setLimit,
    setPage,
    totalPages,
    limit,
    page,
    setSelectedAction,
    selectedCurrency,
    selectedAction,
    search,
    state,
    setState,
    casinoTransactions,
    loading,
    status,
    setStatus,
    selectedClient,
    selectedPortal,
    setSelectedClient,
    setSelectedPortal,
    getCsvDownloadUrl,
    handleDownload,
    setSelectedFilter,
    selectedFilter,
    onResetDateFiltered,
    setSearchGameName,
    searchGameName,
    totalCount
  } = useCasinoTransactionsList()

  const {
    visibleColumns,
    pageData,
    customColSetting,
    noDataFound,

  } = useTableCustom(casinoTransactions?.rows,
    tableCasinotransactionColumns,
    false,
    () => { },
    null,
    null,
    false,
    "",
    true,
    "casino_transactions");



  const headerRef = useRef(null);
  const filterRef = useRef(null);
  const paginationRef = useRef(null);
  const [tableMaxHeight, setTableMaxHeight] = useState("60vh");

  useEffect(() => {
    const updateMaxHeight = () => {
      const headerHeight = headerRef.current?.offsetHeight || 0;
      const filterHeight = filterRef.current?.offsetHeight || 0;
      const paginationHeight = paginationRef?.current?.offsetHeight || 0;

      const responsiveTable = document.querySelector('.table-responsive');
      const totalHeight = headerHeight + filterHeight + paginationHeight;
      const availableHeight = window.innerHeight - totalHeight - 110;

      if (window.innerWidth < 1000) {
        // For smaller screens: reset to full height
        if (responsiveTable) {
          responsiveTable.style.maxHeight = '100%';
          responsiveTable.style.overflowY = 'unset';
        }
        setTableMaxHeight('100%');
        return;
      }
      else if (responsiveTable) {
        responsiveTable.style.maxHeight = `${availableHeight}px`;
        responsiveTable.style.overflowY = 'auto'; // ensure scrolling
      }

      setTableMaxHeight(`${availableHeight}px`);
    };

    updateMaxHeight();
  }, [casinoTransactions, loading, visibleColumns]);



  return (
    <>
      <div className='section-header-wrap mt-0 mx-n3'>
        <Row className='align-items-center justify-content-between' ref={headerRef}>
          <Col>
            <h2 className='title-text'>Casino Transactions </h2>
          </Col>
          <Col xs={2} className="text-end">
            <NotificationIconContainer />
          </Col>
        </Row>
      </div>

      <div className="FormsBg" ref={filterRef}>
        <Row className="g-2 align-items-center" style={{ rowGap: "0.25rem" }}>

          {/* <CustomCol xs={12} md={3} lg={2}>
            <Form.Select
              size="sm"
              onChange={(e) => setSelectedCurrency(e.target.value)}
              value={selectedCurrency}
              className="mb-2 mb-md-0"
            >
              <option value=''>Select a Currency</option>
              {allCurrencies && allCurrencies?.rows?.map(
                ({ name: currName, currencyId, code }) => (
                  <option key={currencyId} value={code}>
                    {currName}
                  </option>
                )
              )}
            </Form.Select>
          </CustomCol> */}

          <CustomCol xs={12} md={3} lg={2}>
            <Form.Select
              size="sm"
              onChange={(e) => setSelectedAction(e.target.value)}
              value={selectedAction}
              className="mb-2 mb-md-0"
            >
              {transactionType && transactionType?.map(
                ({ label, value }) => (
                  <option key={label} value={value}>
                    {label}
                  </option>
                )
              )}
            </Form.Select>
          </CustomCol>

          <CustomCol xs={12} md={4} lg={2}>
            <Form.Control
              size="sm"
              type="search"
              value={search}
              placeholder="Search by Email"
              onChange={e =>
                setSearch(e.target.value.replace(/[~`!$%^&*#=)()><?]+/g, ''))}
              className="mb-2 mb-md-0"
            />
          </CustomCol>

          <CustomCol xs={12} md={4} lg={2}>
            <Form.Control
              size="sm"
              type="search"
              value={
                searchGameName}
              placeholder="Search by Game Name"
              onChange={e =>
                setSearchGameName
                  (e.target.value.replace(/[~`!$%^&*#=)()><?]+/g, ''))}
              className="mb-2 mb-md-0"
            />
          </CustomCol>


          <CustomCol xs={12} md={3} lg={2}>
            <DateFilterDropdown state={state} setState={setState} selectedFilter={selectedFilter} setSelectedFilter={setSelectedFilter} />
          </CustomCol>

          {selectedFilter === "custom" && <CustomCol xs={12} md={3} lg={3}>
            <DateRangePicker
              state={state}
              setState={setState}
              size="sm"
              className="mb-2 mb-md-0"
              isMAXwidth={true}
            />
          </CustomCol>}


          <Row className="g-2 align-items-center mt-2 mt-md-0">
            <Col >
              <div className="d-flex flex-column flex-sm-row justify-content-between gap-2 w-100">
                <div>
                  <Button
                    className="d-flex align-items-center btn-primary gap-3"
                    style={{ height: '2.2rem', minWidth: 'max-content' }}
                    size="sm"
                    onClick={() => {
                      setSearch('')
                      setSelectedAction('all')
                      setSelectedCurrency('')
                      setSelectedClient('')
                      setLimit(15)
                      setPage(1)
                      onResetDateFiltered()
                      // setState([
                      //   {
                      //     startDate: null,
                      //     endDate: null,
                      //     key: 'selection'
                      //   }
                      // ])
                      setStatus('all')
                    }}
                  >
                    <span>Reset Filters</span>
                    <FontAwesomeIcon icon={faRedoAlt} />
                  </Button>
                </div>
                <div className="d-flex flex-column flex-sm-row gap-2 align-items-start align-items-sm-center ms-md-auto">

                  <div>
                    {customColSetting}
                  </div>                <Button
                    className="d-flex align-items-center btn-primary gap-2 ms-2"
                    style={{ height: '2.2rem', minWidth: 'max-content' }}
                    size="sm"
                    disabled={casinoTransactions?.count === 0}
                    onClick={() => handleDownload('csv', 'Casino Transactions')}
                  // onClick={() => {
                  //   downloadFile(getCsvDownloadUrl())
                  // }}
                  >
                    <FontAwesomeIcon icon={faFileDownload} />
                    <span>
                      Download CSV
                    </span>
                  </Button>
                </div>
              </div>
            </Col>
          </Row>



        </Row>
      </div>

      {visibleColumns?.length > 0 ? <CasinoTransactionsList
        page={page}
        setLimit={setLimit}
        limit={limit}
        setPage={setPage}
        totalPages={totalPages}
        transactions={casinoTransactions}
        isTenant={false}
        loading={loading}
        tableMaxHeight={tableMaxHeight}
        paginationRef={paginationRef}
        visibleColumns={visibleColumns}
        istoggleColumn={true}
        showTotalCount={true}
        totalCount={totalCount}
        countText={"Total Casino Transactions : "}

      /> : <div>
        <TableErrorMessage />
      </div>}
    </>
  )
}

export default CasinoTransactions
